/* Saved Shopify content only. No demo product facts, prices or cart state. */
(() => {
 'use strict';
 const trim = value => String(value ?? '').trim();
 const fitLabels = new Set(['support','rise','inseam','length','fit','compression','waist','hip','bust','underbust','leg opening','body length','sleeve length','chest (flat)','waist (flat)','hip (flat)','underband (flat)','front rise','back rise','shoulder width','hem width','chest width','underband width','waist width']);
 const rowGroup = row => row.selector !== 'Shared' || fitLabels.has(row.label.toLowerCase()) ? 'fit' : 'details';
 function parseRows(raw) {
  return (Array.isArray(raw) ? raw : []).flatMap(line => {
   const parts = String(line).split('|').map(trim);
   return parts.length === 3 && parts.every(Boolean) ? [{selector:parts[0].toLowerCase()==='shared'?'Shared':parts[0], label:parts[1], value:parts[2]}] : [];
  });
 }
 function resolveRows(rows, variant, options) {
  const sizeIndex = (options || []).findIndex(name => trim(name).toLowerCase() === 'size');
  const size = sizeIndex < 0 ? '' : variant?.options?.[sizeIndex];
  const matches = new Map();
  for (const row of rows) {
   const rank = row.selector === 'Shared' ? 0 : variant && row.selector === variant.title ? 2 : size && row.selector === size ? 1 : -1;
   if (rank < 0) continue;
   const key = row.label.toLowerCase();
   if (!matches.has(key) || rank >= matches.get(key).rank) matches.set(key,{...row,rank});
  }
  return [...matches.values()];
 }
 class ProductDetails extends HTMLElement {
  connectedCallback() {
   if (this.ready) return; this.ready = true; this.listeners = new AbortController();
   try { this.data = JSON.parse(this.querySelector('[data-details-data]').textContent); } catch (_) { return; }
   this.rows = parseRows(this.data.rows);
   this.measurements=window.ProductMeasurements?.create(this,this.data);
   this.tabs = [...this.querySelectorAll('[data-detail-tab]')];
   this.panels = [...this.querySelectorAll('[data-detail-panel]')];
   const tablist = this.querySelector('.design-notes__tabs');
   if (this.tabs.length > 1 && tablist) {
    tablist.hidden = false; tablist.setAttribute('role','tablist');
    this.tabs.forEach((tab,index) => {
     const panel = this.panels.find(node => node.dataset.detailPanel === tab.dataset.detailTab);
     if (!panel) return;
     tab.id = panel.id + '-tab'; tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panel.id);
     panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',tab.id); panel.tabIndex = 0;
     tab.addEventListener('click',()=>this.activate(index),{signal:this.listeners.signal});
     tab.addEventListener('keydown',event=>{
      let next = index;
      if (event.key==='ArrowRight') next = (index+1)%this.tabs.length;
      else if(event.key==='ArrowLeft') next = (index+this.tabs.length-1)%this.tabs.length;
      else if(event.key==='Home') next = 0;
      else if(event.key==='End') next = this.tabs.length-1;
      else return;
      event.preventDefault();this.activate(next);this.tabs[next].focus();
     },{signal:this.listeners.signal});
    });
    this.activate(0); this.dataset.enhanced = 'true';
   } else if (this.tabs.length === 1) {
    this.dataset.enhanced = 'true';
    this.measurements?.showFit(this.tabs[0]?.dataset.detailTab==='fit');
   }
   this.main = [...document.querySelectorAll('[data-rx-main-product]')].find(node=>String(node.dataset.productId)===String(this.data.productId));
   this.update(this.data.variants?.find(v=>String(v.id)===String(this.data.selectedId)) || null);
   if (this.main) {
    this.change = event => {if(event.target.closest('variant-selects')) this.update(null,true);};
    this.error = ()=>this.update(null);
    this.main.addEventListener('change',this.change,true);
    this.main.addEventListener('rulnx:variant-error',this.error);
    if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') {
     this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
      if(String(data.sectionId)!==String(this.main.dataset.section))return;
      const requiresSize = this.main.dataset.rxRequireSize === 'true';
      const sizeGroup=this.main.querySelector('[data-rx-option="size"]');
      const chosenSize=sizeGroup?.querySelector('input:checked')?.value || sizeGroup?.querySelector('select')?.value;
      const variant = requiresSize && !chosenSize ? null : this.data.variants?.find(v=>String(v.id)===String(data.variant?.id));
      this.update(variant || null);
     });
    }
   }
  }
  disconnectedCallback(){this.measurements?.destroy();this.listeners?.abort();this.unsubscribe?.();this.main?.removeEventListener('change',this.change,true);this.main?.removeEventListener('rulnx:variant-error',this.error);this.ready=false;}
  activate(index){
   this.measurements?.showFit(this.tabs[index]?.dataset.detailTab==='fit');
   this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels.find(p=>p.dataset.detailPanel===tab.dataset.detailTab).hidden=i!==index;});
   const tab=this.tabs[index],list=tab?.parentElement;if(!list)return;
   const item=tab.getBoundingClientRect(),bounds=list.getBoundingClientRect();
   if(item.right>bounds.right)list.scrollLeft+=item.right-bounds.right;
   else if(item.left<bounds.left)list.scrollLeft-=bounds.left-item.left;
  }
  update(variant,pending=false){
   const resolved=resolveRows(this.rows,variant,this.data.options);
   const facts=window.ProductMeasurements?.facts(resolved,this.data.type)||[];
   const factHost=this.querySelector('[data-product-facts]');
   if(factHost){const fragment=document.createDocumentFragment();for(const row of facts){const item=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=row.label;dd.textContent=row.value;dd.setAttribute('data-measurement-text','');item.append(dt,dd);fragment.append(item);}factHost.replaceChildren(fragment);factHost.hidden=!facts.length;}

   for(const list of this.querySelectorAll('[data-specification-rows]')){
    const fragment=document.createDocumentFragment();
    for(const row of resolved.filter(row=>rowGroup(row)===list.dataset.specificationRows && !(list.dataset.specificationRows==='fit' && window.ProductMeasurements?.length(row)) && !(list.dataset.specificationRows==='details' && facts.includes(row)))){
     const item=document.createElement('li'),label=document.createElement('span'),value=document.createElement('span');
     label.className='design-notes__fact-label';label.textContent=row.label+':';value.textContent=row.value;value.setAttribute('data-measurement-text','');
     item.append(label,document.createTextNode(' '),value);fragment.append(item);
    }
    list.replaceChildren(fragment);
   }
   const sku=this.querySelector('[data-details-sku]');if(sku)sku.textContent=pending?'Updating selection...':variant?.sku?'SKU: '+variant.sku:variant?'SKU not assigned':'Select options to show SKU';
   this.measurements?.update(resolved,variant,pending);
   const note=this.querySelector('[data-specification-note]');if(note){note.hidden=Boolean(variant)||!this.rows.some(r=>r.selector!=='Shared')||Boolean(this.measurements&&!this.measurements.box?.hidden);note.textContent=pending?'Updating size-specific measurements...':'Select your size to see its finished-garment measurements.';}
   const descriptor=[...document.querySelectorAll('[data-product-descriptor]')].find(n=>String(n.dataset.productDescriptor)===String(this.data.productId));
   if(descriptor){const keys=['support','rise','inseam','capacity','dimensions'];const copy=keys.flatMap(key=>{const r=resolved.find(v=>v.label.toLowerCase()===key);return r?[r.value+(key==='inseam'&&!/inseam/i.test(r.value)?' inseam':key==='support'&&!/support/i.test(r.value)?' support':'')]:[];}).slice(0,3).join(' · ');descriptor.textContent=copy;descriptor.setAttribute('data-measurement-text','');descriptor.hidden=!copy;}
  }
 }
 class FeatureRail extends HTMLElement {
  connectedCallback(){
   if(this.listeners)return;
   const slider=this.querySelector('slider-component'),rail=this.querySelector('.design-story__grid'),controls=this.querySelector('.slider-buttons');if(!slider||!rail||!controls)return;
   this.listeners=new AbortController();const options={signal:this.listeners.signal,passive:true};
   const place=()=>{
    this.frame=null;if(matchMedia('(min-width:990px)').matches)return;
    const items=[...rail.querySelectorAll('.design-story__item')],bounds=rail.getBoundingClientRect();
    const current=items.reduce((best,item)=>{const r=item.getBoundingClientRect(),visible=Math.max(0,Math.min(r.right,bounds.right)-Math.max(r.left,bounds.left));return visible>best.visible?{item,visible}:best;},{visible:-1}).item;
    if(!current)return;const photo=current.querySelector('figure').getBoundingClientRect(),host=slider.getBoundingClientRect();
    slider.style.setProperty('--feature-controls-left',Math.max(0,Math.min(photo.right,host.right)-host.left-controls.offsetWidth-8)+'px');
    slider.style.setProperty('--feature-controls-top',(photo.bottom-host.top-controls.offsetHeight-8)+'px');
   };
   const queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(place);};
   rail.addEventListener('scroll',queue,options);slider.addEventListener('slideChanged',queue,options);
   this.resize=new ResizeObserver(queue);this.resize.observe(slider);queue();
  }
  disconnectedCallback(){this.listeners?.abort();this.listeners=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);}
 }
 class FeaturePanel extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;
   const button=this.querySelector('.design-story__info'),text=this.querySelector('.design-story__reveal');if(!button||!text)return;
   this.ready=true;this.listeners=new AbortController();this.dataset.enhanced='true';button.hidden=false;
   let pinned=false,hovering=false,suppressed=false;const label=button.getAttribute('aria-label');
   const update=()=>{const open=pinned||(hovering&&!suppressed);this.toggleAttribute('data-open',open);button.setAttribute('aria-expanded',String(open));button.setAttribute('aria-label',open?'Close information':label);button.querySelector('span').textContent=open?'×':'i';text.setAttribute('aria-hidden',String(!open));};
   const options={signal:this.listeners.signal};
   this.addEventListener('pointerenter',event=>{if(event.pointerType==='touch'||!matchMedia('(hover:hover) and (pointer:fine)').matches)return;hovering=true;suppressed=false;update();},options);
   this.addEventListener('pointerleave',()=>{hovering=false;suppressed=false;update();},options);
   button.addEventListener('click',()=>{const open=this.hasAttribute('data-open');pinned=!open;suppressed=open;update();},options);
   this.addEventListener('keydown',event=>{if(event.key==='Escape'&&this.hasAttribute('data-open')){event.preventDefault();pinned=false;suppressed=true;update();button.focus({preventScroll:true});}},options);
   update();
  }
  disconnectedCallback(){this.listeners?.abort();this.ready=false;}
 }
 class ShopLook extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.addEventListener('click',event=>{
    const point=event.target.closest('[data-look-point]');if(!point)return;
    const card=this.querySelector('[data-look-card="'+point.dataset.lookPoint+'"]');if(!card)return;
    event.preventDefault();this.querySelectorAll('[data-look-point]').forEach(p=>p.setAttribute('aria-current',String(p===point)));this.querySelectorAll('[data-look-card]').forEach(c=>c.toggleAttribute('data-selected',c===card));
    const choose=card.querySelector('[data-companion-open],.companion-open');
    if(choose){const form=card.querySelector('[data-rx-quick-form]');if(form&&window.CompanionSheet?.open)window.CompanionSheet.open(form,point);else choose.click();}else{card.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});card.focus({preventScroll:true});}
   });
  }
 }
 function wearLinks(){document.querySelectorAll('.product-wear-links').forEach(nav=>{let visible=false;nav.querySelectorAll('[data-wear-link]').forEach(link=>{
  const target=document.getElementById(link.getAttribute('href').slice(1));
  const ready=Boolean(target&&!target.hidden&&target.querySelector('.rx-match-card'));link.hidden=!ready;visible ||= ready;
 });nav.hidden=!visible;});}
 if(!customElements.get('product-details'))customElements.define('product-details',ProductDetails);
 if(!customElements.get('shop-look'))customElements.define('shop-look',ShopLook);
 if(!customElements.get('feature-panel'))customElements.define('feature-panel',FeaturePanel);
 if(!customElements.get('feature-rail'))customElements.define('feature-rail',FeatureRail);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wearLinks);else wearLinks();
 document.addEventListener('profile-products:loaded',wearLinks);document.addEventListener('shopify:section:load',wearLinks);
})();
